import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../src/styles/userManagement.css";
import UpdateRisk from "./updateRiskTable"
export default function Risk() {
  const [currentTab, setCurrentTab] = useState("1");
  const [messageScreen, setMessageScreen] = useState(false)
  const [modalVisible, setModalVisible] = useState(false);
  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };
  const ChangeTab = (id) => {
    setCurrentTab(id)
  }
  const data2 = [
    {
      "Risk ID": "TP910",
      "Status": "Expired",
      "Third Party Name": "James",
      "Service Name": "IT-Service",
      "Business Owner": "yash",
      "Date Issued": "11-Sep-2020",
      "Information Classification": "NA"
    },

    {
      "Risk ID": "TP789",
      "Status": "Open",
      "Third Party Name": "Rambabu",
      "Service Name": "Business Service",
      "Business Owner": "Nidhi",
      "Date Issued": "15-Oct-2020",
      "Information Classification": "NA"
    },
    {
      "Risk ID": "TP112",
      "Status": "Close",
      "Third Party Name": "Ram",
      "Service Name": "IT-Service",
      "Business Owner": "Ram",
      "Date Issued": "16-Nov-2020",
      "Information Classification": "NA"
    },
    {
      "Risk ID": "TP456",
      "Status": "Expired",
      "Third Party Name": "Nagaraj",
      "Service Name": "NA",
      "Business Owner": "Drake",
      "Date Issued": "21-Oct-2020",
      "Information Classification": "NA"
    },
    {
      "Risk ID": "TP123",
      "Status": "Close",
      "Third Party Name": "James",
      "Service Name": "Business Service",
      "Business Owner": "Post Malone",
      "Date Issued": "16-Feb-2020",
      "Information Classification": "NA"
    },
  ]

  const riskTable = () => {
    // $(document).ready(function () {
    //   $('#risk').DataTable({
    //     "scrollX": true, "initComplete": function (settings, json) {
    //       $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
    //     }, data: data2,
    //     destroy: true,
    //     info: false,
    //     language: {
    //       paginate: {
    //         next: '&gt;', // or '→'
    //         previous: '&lt;' // or '←' 
    //       }
    //     },
    //     fields: [
    //       {
    //         label: "Risk ID",
    //         name: "Risk ID",
    //       },
    //       {
    //         label: "Status",
    //         name: "Status",
    //       },
    //       {
    //         label: "Third Party Name:",
    //         name: "Third Party Name",
    //       },
    //       {
    //         label: "Service Name:",
    //         name: "Service Name",
    //       },
    //       {
    //         label: "Business Owner:",
    //         name: "Business Owner",
    //       },
    //       {
    //         label: "Date Issued:",
    //         name: "Date Issued",
    //       },


    //     ],
    //     columns: [
    //       { data: "Risk ID" },
    //       {
    //         render: function (data, type, row) {
    //           let stylesClass
    //           switch (row["Status"]) {
    //             case "Expired":
    //               stylesClass = "Expired-status";
    //               break;
    //             case "Open":
    //               stylesClass = "Open-status";
    //               break;
    //             case "Close":
    //               stylesClass = "Close-status";
    //               break;
    //             default:
    //               stylesClass = "";
    //           }
    //           return (
    //             `<div class="bia-status ${stylesClass}">${row["Status"]}</div>`
    //           )
    //         }
    //       },
    //       { data: "Third Party Name" },
    //       { data: "Service Name" },
    //       { data: "Business Owner" },
    //       { data: "Date Issued" },
    //       { data: "Information Classification" },

    //       {
    //         render: function (data, type, row) {
    //           return (
    //             '<span class=" appkiticon icon-edit-fill pointer" data-toggle="modal" data-target="#updateModal" id="edit_' +
    //             row.org_level + "_*_*" + row.org_name + "_*_*" + row.org_parent + "_*_*" + row.org_child + "_*_*" + row.org_id +
    //             '"> </span> &nbsp;<span class=" appkiticon icon-delete-fill pointer" data-toggle="modal" data-target="#deleteModal" id="ven_del' +
    //             row.org_id +
    //             '"> </span>'
    //           );
    //         },
    //       },
    //     ]
    //   });
    // });
  }
  useEffect(() => {
    riskTable()
  }, []);
  $(document).on("click", "[id*='ven_del']", function () {
    setModalVisible(true);
  });
  $(document).on("click", "[id*='edit_']", function () {
    setMessageScreen(true);
  });
  return (
    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab value="1" label="Update Risks">
            < UpdateRisk SetTab={ChangeTab} />
          </Tab>
        </Tabs>
      </div>
    </div>
  )
};
